export let dict = () =>{
    return {
        "cellLine": {
            "B": "B16",
            "C": "CT26",
            "K": "KPC",
            "L": "LLC",
            "M": "MC38",
            "P": "Panc02",
            "R": "Renca",
            "Y": "Yummer"
        },
        "screenLibrary": {
            "g": "Genome",
            "p": "Subgenome",
            "c": "Chromatin Regulator"
        },
        "condition": {
            "IN": "Input",
            "OUT": "Output",
            "NSG": "NSG",
            "WT": "WT",
            "IO": "ICB"
        },
        "conditionPair": {
            "IN": "ICB vs NSG",
            "WN": "WT vs NSG",
            "NO": "NSG vs Output",
            "OI": "Output vs Input",
            "IW": "ICB vs WT",
            "IO": "ICB vs Output",
            "II": "ICB vs Input",
            "WO": "WT vs Output",
            "WI": "WT vs Input",
            "NI": "NSG vs Input"
        },
        "conditionRnaSeq": {
            "NS": "NS",
            "g": "IFNg",
            "b": "IFNb",
            "a": "TNFa"
        
        },
        "conditionOrder": {
            "IN": 1,
            "OUT": 2,
            "NSG": 3,
            "WT": 4,
            "IO": 5
        }
    }
   
}

export const cellLineConditions = {
            "B": ["IN", "OUT", "NSG", "WT", "IO"],
            "C": ["IN", "OUT", "NSG", "WT", "IO"],
            "K": ["IN", "OUT", "NSG", "WT", "IO"],
            "L": ["IN", "OUT", "NSG", "IO"],
            "M": ["IN", "OUT", "NSG", "WT", "IO"],
            "P": ["IN", "OUT", "NSG", "WT", "IO"],
            "R": ["IN", "NSG", "WT", "IO"],
            "Y": ["IN", "OUT", "NSG", "WT", "IO"]
    }


export const extents = ()=>{
    return {
        volcano:{
            x: [-5,5],
            y: [0,12],
            xMetric: "Log2 (fold change)",
            yMetric: "-Log10 (p value)"
        },
        scatter: {
            x: [-5,5],
            y: [-5,5],
            xMetric: "Log2 (fold change)",
            yMetric: "Log2 (fold change)"
        }
    }

}

export function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}


export function roundDecimal(input){
    return input.toFixed(1)
}

export const dy = {
    tick: 7,
    columTitle: 10
}
const blue = "#1F2B7B", 
    green = "#008A7C",
    pink = "#EF4782",
    yellow = "#FBAD18",
    purple="#AA0072",
    orange="#F37121",
    lightpurple = "#BC9DCA";

export const colors = [blue, green, pink, yellow, purple, orange, lightpurple]

export const circle = {
    r: 3.5,
    c:"rgb(20,20,20)"
}
export function euclidDistance(x1, y1, x2, y2){
    return Math.pow(x1-x2, 2) + Math.pow(y1-y2, 2);
  }